const defaultSelectOptions = [
  { key: 'option-1', value: 'Example option' },
  { key: 'option-2', value: 'Second option' }
];

const getPreviewValue = (fieldType, options) => {
  switch (fieldType) {
    case 'richtext':
      return JSON.stringify({
        version: 1,
        type: 'doc',
        content: [
          {
            type: 'heading',
            attrs: { level: 1 },
            content: [{ type: 'text', text: 'Regional expansion announced' }]
          },
          {
            type: 'paragraph',
            content: [{ type: 'text', text: 'Our latest news and updates.' }]
          },
          {
            type: 'bulletList',
            content: [
              {
                type: 'listItem',
                content: [
                  {
                    type: 'paragraph',
                    content: [{ type: 'text', text: 'New location opening' }]
                  }
                ]
              }
            ]
          }
        ]
      });
    case 'number':
      return 123;
    case 'checkbox':
      return false;
    case 'dropdown':
      return options[0]?.key || '';
    case 'multiselect':
      return options.slice(0, 2).map((option) => option.key);
    case 'time':
      return '14:30';
    case 'dateonly':
      return '2026-01-15';
    case 'datetime':
      return '2026-01-15T10:30:00Z';
    case 'url':
      return 'https://example.com';
    default:
      return 'Example value';
  }
};

export const createLayoutPreviewData = (cards = []) => {
  const values = {};
  const previewCards = cards.map((card, cardIndex) => ({
    ...card,
    title: card.title || `Card ${cardIndex + 1}`,
    items: (card.items || [])
      .filter((item) => item.item_type === 'field')
      .map((item, itemIndex) => {
        const fieldType =
          item.field?.field_type || item.display_field_type || 'text';
        const configuredOptions = item.field?.config?.options;
        const options =
          Array.isArray(configuredOptions) && configuredOptions.length
            ? configuredOptions
            : defaultSelectOptions;
        const fieldId =
          item.field_id || `preview-field-${cardIndex}-${itemIndex}`;

        values[fieldId] =
          fieldType === 'number' && item.field?.config?.format === 'percentage'
            ? 60
            : getPreviewValue(fieldType, options);

        return {
          ...item,
          field_id: fieldId,
          field_value: values[fieldId],
          field: {
            config:
              fieldType === 'richtext'
                ? {}
                : { ...item.field?.config, options },
            description: item.field?.description || '',
            field_type: fieldType,
            label: item.field?.label || item.display_label || 'Field'
          }
        };
      })
  }));

  return { cards: previewCards, values };
};

export const getLayoutPreviewTab = (objectType) => {
  const tabsByObjectType = {
    asset: 'tab0',
    party: 'tab1',
    service: 'tab2',
    contract: 'tab3',
    dashboard: 'tab4',
    entity: 'tab0'
  };

  return tabsByObjectType[objectType] || 'tab0';
};
